import React, { useState, useEffect } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { validateBookServiceForm } from "../utils//validation/book-service";
import { handleErrors } from "../utils/errorHandler";
import { toast } from "react-toastify";
import bookService from "../services//book-services";
import bookServiceBanner from "../assets/images/book-service-banner.png";
import { Link, useNavigate, useParams } from "react-router-dom";
import customerInfoServices from "../services/customer-profile-services";
import { useLocation } from "react-router-dom";
const BookingPage = () => {
  const [errors, setErrors] = useState({});
  const location = useLocation();
  const navigate = useNavigate();
  const { name, workType, amount, subCategoryName } = location.state || {};
  const { id } = useParams();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    userGuid: "",
    userName: "",
    emailAddress: "",
    contactNo: "",
    serviceId: id || 0,
    flatNumber: "",
    streetCross: "",
    locality: "",
    pincode: "",
    addlComments: "",
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validateBookServiceForm(formData);
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length === 0) {
      setIsSubmitting(true);
      try {
        const serviceResponse = await bookService.submitServicesForm(formData);

        if (serviceResponse.status === 200) {
          const { bookingNo } = serviceResponse.data.result;
          setFormData({
            userGuid: "",
            userName: "",
            emailAddress: "",
            contactNo: "",
            serviceId: id || 0,
            flatNumber: "",
            streetCross: "",
            locality: "",
            pincode: "",
            addlComments: "",
          });
          toast.success(
            "Booking requested successfully. Our backend team will get back to you ASAP."
          );
          navigate("/booking-success", {
            state: { bookingNo },
          });
        } else {
          throw new Error("Failed to book the service.");
        }
      } catch (error) {
        let errorMessage = handleErrors(error);
        if (error.response && error.response.status === 500) {
          errorMessage = error.response.data.message;
        }
        toast.error(errorMessage);
      } finally {
        setIsSubmitting(false);
      }
    }
  };
  async function fetchProfileData() {
    try {
      const response = await customerInfoServices.getProfileInfo();
      const data = response.data.result;
      setFormData((prevData) => ({
        ...prevData,
        userGuid: data.ownerGuid || "",
        userName: data.ownerName || "",
        contactNo: data.phoneNo || "",
        emailAddress: data.emailAddress || "",
        flatNumber: data.ownerAddress?.houseNo || "",
        streetCross: data.ownerAddress?.roadName || "",
        locality: data.ownerAddress?.locality || "",
        pincode: data.ownerAddress?.pincode || "",
        serviceId: prevData.serviceId, // Ensure serviceId is not lost
      }));
    } catch (error) {
      toast.error(handleErrors(error));
    }
  }

  useEffect(() => {
    fetchProfileData();
  }, []);
  return (
    <>
      <section className="inner-full-banner">
        <div className="banner-img-wrap">
          <img src={bookServiceBanner} alt="" />
        </div>
      </section>
      <section className="section-padding pt-0">
        <Container>
          <Row>
            <Col lg={10} className="mx-auto">
              <div className="service-booking-form">
                <Row>
                  <Col lg={12}>
                    <div className="section-title">
                      <h2>Book a Service</h2>
                      <div className="book-service-info">
                        <p>
                          Need reliable facility management and maintenance
                          services? We've got you covered! At Cureanza, we offer
                          professional, efficient, and hassle-free services to
                          keep your property clean, safe, and well-maintained.
                        </p>
                        <ul>
                          <li>
                            <span className="name">Service Name</span>
                            <span className="value">{name}</span>
                          </li>
                          <li>
                            <span className="name">Work Type</span>
                            <span className="value">{workType}</span>
                          </li>

                          <li>
                            <span className="name">Service Type</span>
                            <span className="value">{subCategoryName}</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </Col>
                  <Col lg={12}>
                    <Form className="booking-card" onSubmit={handleSubmit}>
                      <div className="row">
                        <div className="col-md-6">
                          <Form.Group className="mb-3">
                            <Form.Label>
                              Name<span className="imp-star">*</span>
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="userName"
                              value={formData.userName}
                              onChange={handleChange}
                            />
                            {errors.userName && (
                              <div className="text-danger">
                                {errors.userName}
                              </div>
                            )}
                          </Form.Group>
                        </div>
                        <div className="col-md-6">
                          <Form.Group className="mb-3">
                            <Form.Label>
                              Email<span className="imp-star">*</span>
                            </Form.Label>
                            <Form.Control
                              type="email"
                              name="emailAddress"
                              onChange={handleChange}
                              value={formData.emailAddress}
                            />
                            {errors.emailAddress && (
                              <div className="text-danger">
                                {errors.emailAddress}
                              </div>
                            )}
                          </Form.Group>
                        </div>
                        <div className="col-md-6">
                          <Form.Group className="mb-3">
                            <Form.Label>
                              Contact No<span className="imp-star">*</span>
                            </Form.Label>
                            <Form.Control
                              type="text"
                              maxLength={10}
                              onChange={handleChange}
                              name="contactNo"
                              value={formData.contactNo}
                            />
                            {errors.contactNo && (
                              <div className="text-danger">
                                {errors.contactNo}
                              </div>
                            )}
                          </Form.Group>
                        </div>
                        <div className="col-md-6">
                          <Form.Group className="mb-3">
                            <Form.Label>
                              House/Flat Number
                              <span className="imp-star">*</span>
                            </Form.Label>
                            <Form.Control
                              type="text"
                              onChange={handleChange}
                              name="flatNumber"
                              value={formData.flatNumber}
                            />
                            {errors.flatNumber && (
                              <div className="text-danger">
                                {errors.flatNumber}
                              </div>
                            )}
                          </Form.Group>
                        </div>
                        <div className="col-md-6">
                          <Form.Group className="mb-3">
                            <Form.Label>
                              Street / Cross<span className="imp-star">*</span>
                            </Form.Label>
                            <Form.Control
                              type="text"
                              onChange={handleChange}
                              name="streetCross"
                              value={formData.streetCross}
                            />
                            {errors.streetCross && (
                              <div className="text-danger">
                                {errors.streetCross}
                              </div>
                            )}
                          </Form.Group>
                        </div>
                        <div className="col-md-6">
                          <Form.Group className="mb-3">
                            <Form.Label>Locality/ Area</Form.Label>
                            <Form.Control
                              type="text"
                              onChange={handleChange}
                              name="locality"
                              value={formData.locality}
                            />
                            {errors.locality && (
                              <div className="text-danger">
                                {errors.locality}
                              </div>
                            )}
                          </Form.Group>
                        </div>
                        <div className="col-md-6">
                          <Form.Group className="mb-3">
                            <Form.Label>Pincode</Form.Label>
                            <Form.Control
                              type="text"
                              onChange={handleChange}
                              name="pincode"
                              value={formData.pincode}
                            />
                            {errors.pincode && (
                              <div className="text-danger">
                                {errors.pincode}
                              </div>
                            )}
                          </Form.Group>
                        </div>
                        <div className="col-md-12">
                          <Form.Group className="mb-4">
                            <Form.Label>Any Additional Comments ?</Form.Label>
                            <Form.Control
                              as="textarea"
                              className=""
                              name="addlComments"
                              onChange={handleChange}
                              rows={5}
                              value={formData.addlComments}
                            />
                          </Form.Group>
                        </div>
                        <div className="col-12 mt-4">
                          <Button
                            className="btn orange-btn mt-3"
                            type="submit"
                            disabled={isSubmitting}
                          >
                            {isSubmitting ? "Booking..." : "Enquiry Now"}
                          </Button>
                        </div>
                      </div>
                    </Form>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default BookingPage;
